module.exports = __webpack_public_path__ + "8285028327cda2858b8aa07b9f299713.obj";